<div [id]="'lane' + lane.id" class="lane_panel box">
  <div class="program_head">
    <div class="program_head_info">
      <div class="lane_title">
        <icon *ngIf="lane.programConfirmed" icon="tick_12px" class="confirmed_tick"></icon>
        <joi-input class="title desktop" type="textarea"
          #titleInput
          [model]="lane.title"
          (joiChange)="updateProgramTitle($event)" 
          [disabled]="!fullAccess || dragging" 
          [placeholder]="uiService.programTerm.btn + ' nickname...'  + (!lane.title && !!first && wide ? ' eg. reception area, main stage etc.' : '')" 
        ></joi-input>
        <div class="title mobile" (click)="editProgram.emit()">
          {{lane.title}}
          <span *ngIf="!lane.title">{{ uiService.programTerm.btn }} nickname...</span>
        </div>
      </div>
      <div class="desc" (click)="editProgram.emit()">
        <div>
          <span class="pointer" *ngIf="lane.locationConfirmed" >
            <icon class="confirmed_tick" icon="tick_12px"></icon>
          </span>
          <span class="pointer" [ngClass]="{waiting:!lane.location}">{{lane.location || 'Venue room/location'}},</span>&nbsp;<span class="pointer" *ngIf="lane.venueConfirmed">
            <icon class="confirmed_tick" icon="tick_12px"></icon>
          </span>
          <span class="pointer" [ngClass]="{waiting:!venue.venue}">{{ venue.venue || 'Venue name'}}</span>
        </div>
        <div>
          @if(!!lane && lane.files && lane.files.length){
            <span class="pointer" *ngIf="!!lane.files?.length">
              <icon class="attachment" matIcon="attachment"></icon>
              {{lane.files.length}}
            </span>
          }
        </div>
        <div class="labels">
          <div class="labels_content" *ngIf="lane.labels && lane.labels.length > 0">
            <div *ngFor="let id of lane.labels">
              <label-item *ngIf="labelMaps.program_labels && labelMaps.program_labels[id] as lbl" [color]="lbl.color" [label]="lbl.label"></label-item>
            </div>
          </div>
        </div>
      </div>
      <div class="expandable_details" [@drop]="{value: programDetailsState }" (click)="programDetailsState = programDetailsState === 'expanded' ? 'collapse':'expanded'">
        <div class="desc pointer padbottom" [ngClass]="{waiting:!venue.address}">{{ venue.address || 'Venue address'}}</div>
        <div class="desc pointer" *ngFor="let file of lane.files">
          <icon class="attachment" matIcon="attachment"></icon>
          {{file.filename}}
        </div>
      </div>
    </div>

    <div class="program_actions">
      <div>
        <div [id]="lane.id + 'Menu'" class="more_vert" [matMenuTriggerFor]="programOptions" *ngIf="fullAccess || isLogistics">
          <icon matIcon="more_vert"></icon>
        </div>
        <mat-menu #programOptions="matMenu" xPosition="before">
          <button mat-menu-item (click)="editProgram.emit()">Manage {{ uiService.programTerm.btn }}</button>
          <button mat-menu-item *ngIf="fullAccess" (click)="duplicateProgram()">Duplicate {{ uiService.programTerm.btn }}</button>
          <button mat-menu-item *ngIf="fullAccess" (click)="deleteProgram()">Delete {{ uiService.programTerm.btn }}...</button>
        </mat-menu>
      </div>
      <div class="more_dropdown" (click)="programDetailsState = programDetailsState === 'expanded' ? 'collapse':'expanded'">
        <icon class="arrow" icon="expand_24px" [ngClass]="{show: programDetailsState === 'expanded'}"></icon>
      </div>
    </div>
  </div>
  <div class="lane_scroller_container">
    <ng-container *ngFor="let day of lane.sessions; trackBy: trackByProgramDay; index as day_idx; first as first; last as day_last">
      @if({ STZAbbr:  !lane || !lane.secondaryTimeZoneDetails || !lane.secondaryTimeZoneDetails.days || !lane.secondaryTimeZoneDetails.days[day_idx] ? null :  lane.secondaryTimeZoneDetails.days[day_idx]?.abbr}; as dayVars ) {
        <div class="title_bar" [ngClass]="{first:first, disabled: !fullAccess}" (click)="day.day !== 1 ? null : editProgram.emit()">
          <span *ngIf="lane.dateConfirmed" class="confirmed_tick">
            <icon class="confirmed_tick" icon="tick_12px"></icon>
          </span>{{ lane | programDayDate:day.day }}
          <icon class="program_date_close" *ngIf="day.day > 1 && fullAccess" (click)="removeDay($event, day)" icon="delete_24px">
          </icon>
        </div>
        <div class="program_start">Start Time
          <joi-input [model]="day.start" (joiChange)="updateStartTime($event, day_idx)" [disabled]="!fullAccess || dragging" class="start_time on-grey" [autoSelect]="true" [placeholder]="'00:00'" [maxlength]="7"></joi-input>
          <span *ngIf="showTimezones && !!lane.timeZoneDetails">{{ lane.timeZoneDetails.days ? lane.timeZoneDetails.days[day_idx].abbr : lane.timeZoneDetails.abbr}}</span>
          <span class="note" *ngIf="!!dayVars.STZAbbr">{{ day | daySecondaryTimezoneText:dayVars.STZAbbr }}</span>
        </div>
        <!-- TODO this goes in the dragula div [dragulaModel]="day.sessions"  dragula="cards-bag"-->
        <div  [attr.id]="lane.id+'-'+day.day" class="cards_container" 
          cdkDropList 
          [cdkDropListData]="{ day, program: lane }"
          (cdkDropListDropped)="drop($event)"
        >
          <div *ngFor="let session of day.sessions | idsToItems:lane.sessions_obj; index as sess_idx; first as first; last as sess_last; trackBy:trackBySessionDescriptionHash.bind(this);" >
             <!--
            <div>
              session {{session?.id}}</div>-->
            <session-card 
            style="display: block;"
              *ngIf="session"
              [id]="'card_' + sess_idx"
              [class]="'card_container ' + session.type" 
              [session]="session"
              [wide]="wide"
              [fullAccess]="fullAccess"
              [dragging]="dragging"
              [canDrag]="canDrag"
              cdkDrag
              [cdkDragData]="{ session, day, lane }"
              [labels]="labelMaps.session_labels"
              [programId]="lane.id"
              [event]="event"
              [ready]="ready"
              [isProgram]="fullAccess"
              [secondaryTimeString]="session | sessionSecondaryTimezoneText:dayVars.STZAbbr || ''"
              [topPopin]="fullAccess && !dragging && !justAddedSession"
              [bottomPopin]="fullAccess && !dragging && !justAddedSession && sess_last && !day_last"
              (deleteBreak)="deleteBreak($event, session, sess_idx)"
              (editSession)="sendEditSession($event, session)"
              (addBetween)="addBetween($event, day_idx, sess_idx)"
            ></session-card>
          </div>
          <session-card *ngIf="!day.sessions.length || (false && day.sessions.length === 1 && !!dragging && draggedDay === day_idx + 1)" [isProgram]="fullAccess" [placeholder]="true" [placeholderText]="!day.sessions.length ? '' : 'End Time ' + day.end" (addBetween)="addBetween($event, day_idx, 0)"></session-card>
        </div>
        <div *ngIf="!!day.sessions.length && !(false && day.sessions.length === 1 && !!dragging  && draggedDay === day_idx + 1)" class="program_end">
          End Time {{day.end}}
          <span *ngIf="lane.secondaryTimeZoneDetails && lane.timeZoneDetails">{{ lane.timeZoneDetails.abbr}}</span>
          <span class="note" *ngIf="lane.secondaryTimeZoneDetails && lane.secondaryTimeZoneDetails.days"> ({{(day.endForStz?.dayOffset ? day.endForStz?.dayOffset+' ' : '') + day.endForStz?.time + ' '+ lane.secondaryTimeZoneDetails.days[day_idx].abbr}})</span>
        </div>
      }
    </ng-container>
  </div>
  <div class="actions" *ngIf="fullAccess"> 
    <button matButton class="plain" (click)="addSession('session')">+ Add a session</button>
    <div style="flex:1;height:100%;" (click)="debugProgram()"></div>
    <button matButton class="plain" (click)="addSession('break')">+ Add out-of-session</button>
  </div>
</div>
<div class="add_day" *ngIf="lane.sessions?.length && fullAccess">
  <button matButton class="plain" (click)="addDay()">+ Add a day</button>
</div>



